import { watch } from 'vue';
import { analyticsEnabled, startAnalytics } from './analytics';
import { analyticsConsent } from './consent';

/**
 * Whether to ask at all: on sulje.com, where analytics exists, and in
 * development so the banner can be seen and tested (nothing loads there).
 */
export const askForConsent = analyticsEnabled || import.meta.env.DEV;

// A "yes" given on this page starts Vahti here, without waiting for the next
// navigation (router.ts starts it on later visits).
watch(analyticsConsent, (value) => {
  if (value === 'granted') startAnalytics(location.pathname);
});
